import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=cb4e6800&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=cb4e6800&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4e6800",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb4e6800')) {
      api.createRecord('cb4e6800', component.options)
    } else {
      api.reload('cb4e6800', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=cb4e6800&scoped=true&", function () {
      api.rerender('cb4e6800', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2S7gYuOmnT64N/JS/comp/SearchFilterTokens.vue"
export default component.exports